import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';
import {
  CommunicationAttachment,
  CommunicationChannel,
  CommunicationLog,
  CommunicationLogListResponse,
  CommunicationSendRequest,
  CommunicationSource,
  CommunicationStatus,
  CommunicationTemplate,
  CommunicationTemplatePreviewResponse,
  CommunicationTemplateUpdate
} from '../_models/communications.models';

const BASE = 'support/communications';

@Injectable({
  providedIn: 'root'
})
export class CommunicationsService {
  constructor(private api: ApiService) {}

  getTemplates(params: {
    channel?: CommunicationChannel;
    template_key?: string;
    portal_tenant_id?: number;
    active_only?: boolean;
  }): Observable<CommunicationTemplate[]> {
    return this.api.getAPI(BASE, params).pipe(map((res: any) => res.body));
  }

  exportTemplates(params: { channel?: CommunicationChannel; active_only?: boolean }): Observable<any> {
    return this.api.getFileAPI(`${BASE}/export`, '', params);
  }

  getTemplate(templateId: number, portalTenantId?: number): Observable<CommunicationTemplate> {
    return this.api
      .getAPI(`${BASE}/${templateId}`, portalTenantId ? { portal_tenant_id: portalTenantId } : undefined)
      .pipe(map((res: any) => res.body));
  }

  updateTemplate(
    templateId: number,
    data: CommunicationTemplateUpdate,
    portalTenantId?: number
  ): Observable<CommunicationTemplate> {
    const query = portalTenantId ? `?portal_tenant_id=${portalTenantId}` : '';
    return this.api
      .patchAPI(`${BASE}/${templateId}${query}`, data)
      .pipe(map((res: any) => res.body));
  }

  previewTemplate(
    templateId: number,
    variables: Record<string, any>,
    portalTenantId?: number
  ): Observable<CommunicationTemplatePreviewResponse> {
    const query = portalTenantId ? `?portal_tenant_id=${portalTenantId}` : '';
    return this.api
      .postAPI(`${BASE}/${templateId}/preview${query}`, { variables })
      .pipe(map((res: any) => res.body));
  }

  getLogs(params: {
    channel?: CommunicationChannel;
    status?: CommunicationStatus;
    template_key?: string;
    source?: CommunicationSource;
    portal_tenant_id?: number;
    portal_customer_id?: number;
    q?: string;
    skip?: number;
    limit?: number;
  }): Observable<CommunicationLogListResponse> {
    return this.api.getAPI(`${BASE}/logs`, params).pipe(map((res: any) => res.body));
  }

  sendCommunication(payload: CommunicationSendRequest): Observable<CommunicationLog> {
    return this.api.postAPI(`${BASE}/send`, payload).pipe(map((res: any) => res.body));
  }

  uploadAttachment(formData: FormData): Observable<CommunicationAttachment> {
    return this.api.postAPI(`${BASE}/attachments`, formData).pipe(map((res: any) => res.body));
  }
}
